import React, { HTMLAttributes, SyntheticEvent, useEffect, useState } from 'react';
import classNames from 'classnames';

import Svg from '../svg/svg';
import star from 'assets/icons/star.svg';
import contour from 'assets/icons/star-contour.svg';
import './rating.scss';

interface RatingProps extends HTMLAttributes<HTMLInputElement> {
    name?: string;
    value?: number;
    max?: number;
    min?: number;
    step?: number;
    width?: number;
    indent?: number;
    readOnly?: boolean;
}

const Rating: React.FC<RatingProps> = (
    {
        value = 0,
        max = 5,
        min = 0,
        step = 0.5,
        width = 100,
        indent = 1,
        readOnly = false,
        className,
        ...props
    }
) => {
    const ratingClasses = classNames(className, 'rating');
    const length = Math.floor(Math.abs(max - min));
    const list = Array.from({ length });
    const starWidth = Math.floor((width - (indent * 2 * length)) / length);

    const calcBackWidth = (newValue: number): number => newValue ? (indent * (2 * Math.ceil(newValue) - 1) + starWidth * newValue) : 0;

    const [backWidth, setBackWidth] = useState(calcBackWidth(value));
    const [current, setCurrent] = useState(value);
    const [average, setAverage] = useState(value);

    const handleMouseMove = ({ nativeEvent }: SyntheticEvent): void => {
        const { offsetX } = (nativeEvent as MouseEvent);
        const result = Math.round(offsetX * length / width / step) * step;

        setAverage(result);
        setBackWidth(calcBackWidth(result));
    };

    const handleClick = (): void => {
        setCurrent(average);
    };

    const handleMouseOut = (): void => {
        setAverage(current);
        setBackWidth(calcBackWidth(current));
    };

    useEffect(() => {
        setAverage(value);
    }, [ value ]);

    return (
        <div className={ratingClasses}>
            <input
                className="rating__input"
                type="range"
                value={average}
                min={min}
                max={max}
                step={step}
                readOnly={readOnly}
                {...props}
                onChange={handleClick}
            />
            <div
                className="rating__label"
                onMouseMove={handleMouseMove}
                onClick={handleClick}
                onMouseOut={handleMouseOut}
            >
                <span className="rating__label-front">
                    {
                        list.map((item, index) => (
                            <Svg style={{ padding: indent }} key={index} path={contour}
                                width={starWidth}
                            />
                        ))
                    }
                </span>
                <span className="rating__label-back-wrapper" style={{ width: backWidth }}>
                    <span className="rating__label-back">
                        {
                            list.map((item, index) => (
                                <Svg style={{ padding: indent }} key={index} path={star}
                                    width={starWidth}
                                />
                            ))
                        }
                    </span>
                </span>

            </div>
            <span className="rating__average">
                {average.toFixed(1)}
            </span>
        </div>

    );
};

export default Rating;
